export const useErrorHandler = () => {
  const notify = useNotifications();
  const { $i18n } = useNuxtApp();
  const bugsnag = useBugsnag();

  const validationErrors = ref({});

  const resetErrors = () => {
    validationErrors.value = {};
  };

  const handleError = (err) => {
    if (
      err.toString().includes("TypeError: Failed to fetch") ||
      err.toString().includes("<no response>") ||
      err.toString().includes("Load failed")
    ) {
      return notify.error($i18n.t("Network error"));
    }

    if (err.status === 400) {
      return notify.error(err.data.message);
    }

    if (err.status === 401) {
      return;
    }

    if (err.status === 404) {
      const message = err.data?.message || null;

      if (message) {
        notify.error(message);
      }

      return;
    }

    if (err.status === 422) {
      validationErrors.value = err.data?.errors;

      return notify.error(err.data.message);
    }

    bugsnag.notify(err);

    notify.error($i18n.t("Something went wrong"));
  };

  return { handleError, validationErrors, resetErrors };
};
